import { Fragment, useEffect, useState, useContext, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import ConfirmContext from "../../../utils/confirmContext";
import SwiperCore, { Pagination, Navigation, Autoplay, EffectFade } from "swiper";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import axios from "axios";
import { useParams } from "react-router";
import config from '../../../configuration/config';
import ImageGallery from "react-image-gallery";
import OverViewContext from "../overviewContext";
import { slugSplitter } from '../../../utils/slugManager';
import NewSitePromo from "../../../components/NewSitePromo";
import { groupBy, mapValues, omit } from "lodash";
import ReactWhatsapp from "react-whatsapp";
import Skeleton from "react-loading-skeleton";
import { EmptyState } from "../../../components/EmptyState";
import { Price } from "../../../components/__simple/_price";
SwiperCore.use([Pagination, Navigation, Autoplay, EffectFade]);

export function VehicleOverViewPage({ setSectionActive, mainurl, setIsLoding, currntvehicle }) {
    const { t: trans, i18n } = useTranslation(["car", "heading", "vehicales", "model", "navbar", "finance", "inputs", "info"]);
    const [selectedColor, setSelectedColor] = useState(null);
    const context = useContext(ConfirmContext);
    const { group, year, brand } = useParams();
    const [vehicle, setVehicle] = useState({});
    const [models, setModels] = useState([]);
    const [features, setFeatures] = useState([]);
    const [gallery, setGallery] = useState([]);
    const [isLoadingImages, setIsLoadingImages] = useState(false);
    const [isLoadingModels, setIsLoadingModels] = useState(true);
    const [isLoadingFeatures, setIsLoadingFeatures] = useState(true);
    const [isLoadingGallery, setIsLoadingGallery] = useState(true);
    const [innerCarImages, setInnerCarImages] = useState([]);
    const [outerCarImages, setOuterCarImages] = useState([]);
    const [wheels, setWheels] = useState([]);
    const [carColors, setCarColors] = useState([]);
    const [activePart, setActivePart] = useState(0);
    const [activeModel, setActiveModel] = useState({});
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    //---------------------------------------------------------
    const popRef = useRef(null);
    let lang = (i18n.language || 'ar');
    const { vehicleInfo, handleChangeOverViewContent } = useContext(OverViewContext);

    const sendRequest = (targetModel) => {
        const payloadModel = targetModel || activeModel;
        try {
            context.onShow({
                displayConfirm: true,
                title: payloadModel?.modelDescription || payloadModel?.name,
                image: payloadModel?.imagePath || payloadModel?.image,
                brand: payloadModel?.brand || brand,
                type: payloadModel?.type,
                isHyper: payloadModel?.hybird,
                isNew: payloadModel?.newCar,
                defaultColorID: payloadModel?.colorID,
                modelYear: payloadModel?.year || year,
                cartDetails: {
                    id: payloadModel?.productID,
                    name: payloadModel?.modelDescription || payloadModel?.name,
                    brand: payloadModel?.brand || brand,
                    image: payloadModel?.imagePath || payloadModel?.image,
                    Type: "car",
                },
                carOrder: {
                    vehicle: payloadModel?.productID,
                    group: payloadModel?.group || group
                },
            });
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {

        if (currntvehicle && currntvehicle?.productID != vehicle?.productID) {
            setIsLoding(true);
            setActiveModel({});
            setActiveOutColor("");
            setActiveINColor("");
            setSelectedColor("");
            resetColorsValues();
            resetValues();
            setVehicle({});
            setModels([]);
            setFeatures([]);
            setGallery([]);
            setCarColors([]);
            setINCarColors([]);
            setOUTCarColors([]);
            setTimeout(() => {
                if (currntvehicle?.productID)
                    callback(currntvehicle);
            }, 1000)
        }

    }, [currntvehicle]);

    useEffect(() => {
        if (activeModel && activeModel?.productID) {

            afterChangeDataType(activeModel);
        }

    }, [activeModel]);

    const callback = useCallback(async (currntvehicle) => {
        var curentCars;
        var firstItem = {};

        // try {
        //     const response = await axios.request({
        //         baseURL: config.controllURL,
        //         url: lang + "/api/VehicleOverview/" + slugSplitter(brand) + "/" + slug + "/overview",
        //         method: "get",
        //     });

        //     setVehicle(response.data.vehicle);
        //     firstItem = response.data.vehicle;

        //     await afterChangeDataType(firstItem);




        // } catch (error) {
        //     console.log(error);

        // }

        // setVehicle(currntvehicle);
        firstItem = currntvehicle;

        // await afterChangeDataType(firstItem);
        //---------------------


        try {
            if ("caches" in window) {
                var curl = lang + "/api/VehicleOverview/" + slugSplitter(currntvehicle?.group) + "/" + currntvehicle?.year + "/models";

                // Opening that particular cache
                const cacheStorage = await caches.open("VehicleOverViewPage");

                // Fetching that particular cache data
                const cachedResponse = await cacheStorage.match(
                    curl
                );
                var datacash = await cachedResponse?.json();

                if (datacash && datacash?.length > 0) {
                    const filteredData = datacash.filter(m => {
                        const combinedFields = `${m.modelDescription} ${m.name} ${m.type} ${m.ColorID} ${m.Reference} ${m.DescriptionEn} ${m.DescriptionAr}`.toLowerCase();
                        return !combinedFields.includes("1l5");
                    });
                    setModels(filteredData);
                    if (filteredData.length > 0) {
                        afterChangeDataType(filteredData[0]);
                        setActiveModel(filteredData[0]);
                    }
                    await getCarModels(filteredData);
                }
            }
        } catch (error) {
        } finally {
            setIsLoadingModels(false);
        }

        try {
            const responsemodels = await axios.request({
                baseURL: config.controllURL,
                url: lang + "/api/VehicleOverview/" + slugSplitter(currntvehicle?.group) + "/" + currntvehicle?.year + "/models",
                method: "get",
            });

            const filteredModels = responsemodels.data.models.filter(m => {
                const combinedFields = `${m.modelDescription} ${m.name} ${m.type} ${m.ColorID} ${m.Reference} ${m.DescriptionEn} ${m.DescriptionAr}`.toLowerCase();
                return !combinedFields.includes("1l5");
            });
            setModels(filteredModels);

            if (filteredModels.length > 0) {
                setActiveModel(filteredModels[0]);
            }
            await getCarModels(filteredModels);

            const dataResponse = new Response(JSON.stringify(filteredModels));

            if ("caches" in window) {
                // Opening given cache and putting our data into it
                caches.open("VehicleOverViewPage").then((cache) => {
                    cache.put(lang + "/api/VehicleOverview/" + slugSplitter(currntvehicle?.group) + "/" + currntvehicle?.year + "/models", dataResponse);

                });
            }

        } catch (error) {
            console.log(error);

        } finally {
            setIsLoadingModels(false);
        }

        //---------------------
        var getCach = false;
        try {
            if ("caches" in window) {
                // var curl = lang + "/api/VehicleOverview/" + slugSplitter(brand) + "/" + slug + "/overviewextra";
                var curlExtra = lang + "/api/VehicleOverview/" + slugSplitter(brand) + "/" + group + "/" + year + "/overviewextra";

                // Opening that particular cache
                const cacheStorage = await caches.open("VehicleOverViewPage");

                // Fetching that particular cache data
                const cachedResponse = await cacheStorage.match(
                    curlExtra
                );
                var datacash2 = await cachedResponse?.json();

                if (datacash2) {

                    setFeatures(datacash2.features);
                    const filterG = [];

                    datacash2?.gallery?.forEach((item, index) => {
                        item["original"] = config.mainURL + item.imagePath;
                        item["thumbnail"] = config.mainURL + item.imagePath;
                        item["originalHeight"] = "50";
                        item["originalWidth"] = "50";
                        item["sizes"] = "50";
                        item["fullscreen"] = config.mainURL + item.imagePath;
                        filterG.push(item);
                    });

                    if (filterG && filterG.length > 0)
                        setGallery(filterG);

                    if (setIsLoding) {
                        setIsLoding(false);
                        getCach = true;
                    }

                }



            }
        } catch (error) {

        } finally {
            setIsLoadingFeatures(false);
            setIsLoadingGallery(false);
        }

        try {
            const response2 = await axios.request({
                baseURL: config.controllURL,
                // url: lang + "/api/VehicleOverview/" + slugSplitter(brand) + "/" + slug + "/overviewextra",
                url: lang + "/api/VehicleOverview/" + slugSplitter(brand) + "/" + group + "/" + year + "/overviewextra",
                method: "get",
            });

            setFeatures(response2.data.features);
            const filterG = [];

            response2?.data?.gallery?.forEach((item, index) => {
                item["original"] = config.mainURL + item.imagePath;
                item["thumbnail"] = config.mainURL + item.imagePath;
                item["originalHeight"] = "50";
                item["originalWidth"] = "50";
                item["sizes"] = "50";
                item["fullscreen"] = config.mainURL + item.imagePath;
                filterG.push(item);
            });

            setGallery(filterG);

            if (setIsLoding && getCach === false) {
                setIsLoding(false);
            }


            const dataResponse2 = new Response(JSON.stringify(response2.data));

            if ("caches" in window) {
                // Opening given cache and putting our data into it
                caches.open("VehicleOverViewPage").then((cache) => {
                    // cache.put(lang + "/api/VehicleOverview/" + slugSplitter(brand) + "/" + slug + "/overviewextra", dataResponse2);
                    cache.put(lang + "/api/VehicleOverview/" + slugSplitter(brand) + "/" + group + "/" + year + "/overviewextra", dataResponse2);

                });
            }


        } finally {
            setIsLoadingFeatures(false);
            setIsLoadingGallery(false);
        }





    }, [group]);
    const [INcolors, setINCarColors] = useState([]);
    const [OUTcolors, setOUTCarColors] = useState([]);
    const [INcolorsCode, setINCarColorsCode] = useState([]);
    const [OUTcolorsCode, setOUTCarColorsCode] = useState([]);
    const [cashCarImages, setCashCarImages] = useState({});
    const [innerCarImagesJson, setInnerCarImagesJson] = useState(null);
    const [outerCarImagesJson, setOuterCarImagesJson] = useState(null);
    useEffect(() => {
        setTimeout(() => {
            if (OUTcolors && OUTcolors.length > 0 && outerCarImagesJson && !outerCarImagesJson[activeOutColor]) {
                var colornew = OUTcolors.find(c => outerCarImagesJson[c.ColorID] != null);
                if (colornew && colornew.ColorID && activeOutColor != colornew.ColorID) {
                    setSelectedColor(null);
                    setActiveOutColor(colornew.ColorID);
                }
            }

        }, 1000)

    }, [outerCarImagesJson, OUTcolors]);


    const fetchCarDesign = async (activeColor, model, partnum = activePart) => {

        if (isLoadingImages == false) {

            setIsLoadingImages(true);
            setFilterCarImages([]);
            var codeColor = partnum == 0 ? activeColor?.split("/")[0] : activeColor?.split("/")[1];
            var codeColorIN = activeColor?.split("/")[1];
            var codeColorOUT = activeColor?.split("/")[0];
            var imagesPart = [];
            const prefix = 'data:image/png;base64,';
            if (model) {
                if (cashCarImages[model + "-part-" + partnum]) {
                    setIsLoadingImages(false);
                    var AllCarImages = cashCarImages[model + "-part-" + partnum];
                    var AllCarImagesIN = cashCarImages[model + "-part-" + 1];
                    var AllCarImagesOUT = cashCarImages[model + "-part-" + 0];

                    setOuterCarImagesJson(AllCarImagesOUT);
                    setInnerCarImagesJson(AllCarImagesIN);
                    if (AllCarImagesIN) {

                        setInnerCarImages(AllCarImagesIN[codeColorIN]);
                    } else {
                        setInnerCarImages([]);

                    }

                    if (AllCarImagesOUT) {

                        setOuterCarImages(AllCarImagesOUT[codeColorOUT]);
                    } else {
                        setOuterCarImages([]);

                    }

                } else {
                    axios.post(
                        `${config.controllURL}${lang}/api/Pages/SiteFetchCarColorCodeImages`,
                        {
                            "Id": model,
                            "year": year,
                            // "ColorID": String(codeColor),
                            "ColorID": null,
                            "FieldNameList": null
                        }
                    ).then(response => {
                        setIsLoadingImages(false);
                        var maincolorimageIndex = 0;
                        if (Array.isArray(response.data)) {
                            const responseData = response.data;
                            // console.log("SiteFetchCarColorCodeImages responseData>>>>>>>>>>>>>>>>>>>>>>>>>:", responseData);
                            const groupResult = mapValues(groupBy(response.data, 'ColorCode'), fList => fList.map(items => omit(items, 'ColorCode')));

                            var allcolor = [...OUTcolorsCode, ...INcolorsCode];


                            allcolor?.map((key, index) => {
                                var colorCodeItems = groupResult[key];
                                if (colorCodeItems?.length > 0) {

                                    if (OUTcolorsCode?.includes(key)) {



                                        var cimage = cashCarImages[model + "-part-" + 0];

                                        if (!cimage) {

                                            cimage = {}
                                        }

                                        cimage[key] = colorCodeItems;
                                        cashCarImages[model + "-part-" + 0] = cimage;
                                        // cashCarImages[model + "-" + key + "-part-" + 0] = colorCodeItems;
                                        if (codeColorOUT == key) {
                                            imagesPart = colorCodeItems;
                                            setOuterCarImages(colorCodeItems);

                                        }

                                    } else if (INcolorsCode?.includes(key)) {

                                        var cimage = cashCarImages[model + "-part-" + 1];

                                        if (!cimage) {

                                            cimage = {}
                                        }

                                        cimage[key] = colorCodeItems;
                                        cashCarImages[model + "-part-" + 1] = cimage;
                                        // cashCarImages[model + "-" + key + "-part-" + 1] = colorCodeItems;
                                        if (codeColorIN == key) {

                                            imagesPart = colorCodeItems;
                                            setInnerCarImages(colorCodeItems);
                                        }


                                    } else {

                                        var cimage = cashCarImages[model + "-part-" + 2];

                                        if (!cimage) {

                                            cimage = {}
                                        }

                                        cimage[key] = colorCodeItems;
                                        cashCarImages[model + "-part-" + 2] = cimage;

                                        // cashCarImages[model + "-" + key + "-part-" + 2] = colorCodeItems;
                                        if (codeColor == key) {

                                            imagesPart = colorCodeItems;
                                            setWheels(colorCodeItems);
                                        }


                                    }
                                }
                            })





                            // console.log("cashCarImages>>>>>>>>>>>>>>>>>>>>>>>>>:", cashCarImages);


                            const imagesCount = imagesPart?.length;

                            var AllCarImagesIN = cashCarImages[model + "-part-" + 1];
                            var AllCarImagesOUT = cashCarImages[model + "-part-" + 0];
                            setOuterCarImagesJson(AllCarImagesOUT);
                            setInnerCarImagesJson(AllCarImagesIN);
                            // console.log("fetchCarDesign AllCarImagesIN:", AllCarImagesIN);
                            // console.log("fetchCarDesign AllCarImagesOUT:", AllCarImagesOUT);

                            if (AllCarImagesIN) {

                                setInnerCarImages(AllCarImagesIN[codeColorIN]);
                            } else {
                                setInnerCarImages([]);

                            }

                            if (AllCarImagesOUT) {

                                setOuterCarImages(AllCarImagesOUT[codeColorOUT]);
                            } else {
                                setOuterCarImages([]);

                            }

                            // setAllCarImages([...outerImages, ...innerImages, ...wheelsImages])
                            setIsLoadingImages(false);




                        }
                    }).catch(error => {
                        console.log(error);
                        setIsLoadingImages(false);
                        cashCarImages[model + "-part-" + partnum] = {};
                    });

                }

            }
        }
    };



    // to change the overview of the vehicle
    const handleRequestChangeOverview = (data, productID) => {
        let result = [];
        const finalItem = {
            name: null,
            isNew: false,
            isHybird: false,
            product: null,
            group: null,
            price: null,
            tax: null,
            gap: '30px',
            discount: 0,
            modelTypes: null
        };
        try {
            if (data) {
                result = data.filter(item => {
                    return String(item.productID) == productID
                });
            } else {
                result = models.filter(item => {
                    return String(item.productID) == productID
                });
            }
            if (result.length > 0) {
                const itemValue = result[0];
                finalItem.modelTypes = itemValue?.type;
                finalItem.isHybird = itemValue?.hybird;
                finalItem.isNew = itemValue?.newCar;
                finalItem.product = itemValue?.productID;
                finalItem.name = itemValue?.name
            }
        } catch (error) {
            console.log(error);
        }
        handleChangeOverViewContent(finalItem);
    };
    // to get the active part of section
    const [filterCarImages, setFilterCarImages] = useState([]);
    const getActivePartSection = async (activePart, thisSelectedColorID = selectedColor?.ColorID, Model = activeModel) => {


        setFilterCarImages([]);
        setActivePart(activePart);
        let result = [];

        if (activePart === 0) {

            if (outerCarImages?.length > 0) {
                result = outerCarImages;

            }

        } else if (activePart === 1) {


            if (innerCarImages?.length > 0) {
                result = innerCarImages;

            }

        } else if (activePart === 2) {

            if (wheels?.length > 0) {
                result = wheels;

            }


        }

        setFilterCarImages(result);
        return result;
    };


    const [cashColors, setCashColors] = useState({});
    const handleFetchModelAvaliableColors = async (productTypeID, currentColorID, year, thisSelectedColorID = selectedColor?.ColorID) => {
        let _colors = [];


        try {

            if (cashColors[productTypeID]) {
                _colors = cashColors[productTypeID];
                setCarColors(_colors);
                let _default = null;

                _default = _colors.find(item => item.ColorID?.trim() === thisSelectedColorID) ?? _colors.find(item => item.ColorID === thisSelectedColorID);
                if (!_default) {
                    _default = _colors.find(item => item.ColorID?.trim() === thisSelectedColorID) ?? _colors.find(item => item.ColorID === currentColorID);
                }


                setSelectedColor(_default);

            } else {

                const response = await axios.post(
                    `${config.controllURL}${lang}/api/Pages/site_fetchColorOfTypeWithOutImages`,
                    {
                        "Type": productTypeID,
                        "model": year
                    }
                );

                if (response.status == 200) {

                    var cc = { ...cashColors };
                    cc[productTypeID] = response.data;
                    setCashColors(cc);




                    _colors = response.data;
                    setCarColors(_colors);
                    let _default = null;

                    _default = _colors.find(item => item.ColorID?.trim() === thisSelectedColorID) ?? _colors.find(item => item.ColorID === thisSelectedColorID);
                    if (!_default) {
                        _default = _colors.find(item => item.ColorID?.trim() === thisSelectedColorID) ?? _colors.find(item => item.ColorID === currentColorID);
                    }

                    setSelectedColor(_default);
                }

            }

        } catch (error) {
            console.log(error);
        }



        return _colors;
    };



    useEffect(() => {

        var currentInColor = [];
        var IN_colors = [];
        var currentOutColor = [];
        var Out_colors = [];

        var jsoncolors = {};
        try {

            carColors?.forEach((item, i) => {

                jsoncolors[item.ColorID] = item;

                if (!currentOutColor.includes(item.ColorID?.split("/")[0])) {

                    Out_colors = [...Out_colors, { ColorDescription: item[lang == "ar" ? `ColorDescriptionAr` : `ColorDescriptionEn`]?.split("/")[0], ColorID: item.ColorID?.split("/")[0], ColorImage: item?.siteOutColorImage }]

                    currentOutColor = [...currentOutColor, item.ColorID?.split("/")[0]]
                }


                if (!currentInColor.includes(item.ColorID?.split("/")[1])) {

                    IN_colors = [...IN_colors, { ColorDescription: item[lang == "ar" ? `ColorDescriptionAr` : `ColorDescriptionEn`]?.split("/")[1], ColorID: item.ColorID?.split("/")[1], ColorImage: item?.siteInColorImage }]

                    currentInColor = [...currentInColor, item.ColorID?.split("/")[1]]
                }


            })


            setOUTCarColorsCode(currentOutColor);
            setINCarColorsCode(currentInColor);
            //---------------

            setINCarColors(IN_colors);
            setOUTCarColors(Out_colors);


        } catch (error) {
            console.log(error);
        }

    }, [carColors]);
    const afterChangeDataType = async (firstItem, thisSelectedColorID = selectedColor?.ColorID, partnum = activePart) => {

        handleRequestChangeOverview(null, firstItem?.productID);
        const colors = await handleFetchModelAvaliableColors(firstItem?.type ?? firstItem?.Type, firstItem?.colorID ?? firstItem?.ColorID, firstItem?.year);
        var currentSelectedColor = colors?.filter(item => item.ColorID?.trim() == thisSelectedColorID)?.length > 0 ? thisSelectedColorID : null;

        if (!currentSelectedColor) {
            currentSelectedColor = colors?.filter(item => item.ColorID == thisSelectedColorID)?.length > 0 ? thisSelectedColorID : colors[0]?.ColorID;
        }
        try {
            if (currentSelectedColor && currentSelectedColor?.split("/")[0] && currentSelectedColor?.split("/")[1]) {
                setActiveOutColor(currentSelectedColor?.split("/")[0]);
                setActiveINColor(currentSelectedColor?.split("/")[1]);

            }
        } catch (error) {
            console.log(error);
        }

        if (firstItem) {
            setCarColors(colors);
            // if (allImagesCount == null)
            fetchCarDesign(currentSelectedColor, firstItem?.productID);
        }
    }


    // to fetch the car models
    const getCarModels = async (allModels) => {
        let models = [];
        try {
            models = allModels?.map((item) => {
                return {
                    text: item.modelDescription, value: item.type
                }
            });
        } catch (error) {
            console.log(error);
        }
    };
    // to reset all the state objects
    const resetValues = () => {
        setOuterCarImagesJson(null);
        setInnerCarImagesJson(null);
        setInnerCarImages([]);
        setOuterCarImages([]);
        setWheels([]);
    };

    const resetColorsValues = () => {
        setOUTCarColors([]);
        setINCarColors([]);

    };

    const [activeINColor, setActiveINColor] = useState("");
    const [activeOutColor, setActiveOutColor] = useState("");
    useEffect(() => {

        if (vehicle?.type)
            setActiveModel(vehicle);

        if (vehicle?.colorID && vehicle?.colorID?.split("/")[0] && vehicle?.colorID?.split("/")[1]) {
            setActiveOutColor(vehicle?.colorID?.split("/")[0]);
            setActiveINColor(vehicle?.colorID?.split("/")[1]);
        }
    }, [vehicle]);


    useEffect(() => {
        // setActivePart(0);

        console.log("activeINColor", activeINColor);
        console.log("activeOutColor", activeOutColor);
        if (activeOutColor && activeINColor) {

            var carcolorthis = carColors.filter(a => a.ColorID?.trim() == (activeOutColor + "/" + activeINColor))[0]

            if (!carcolorthis) {
                carcolorthis = carColors.filter(a => a.ColorID == (activeOutColor + "/" + activeINColor))[0];
            }
            setSelectedColor(carcolorthis);
        }


        if (INcolorsCode?.length > 0 && INcolorsCode?.length > 0 && activeOutColor && activeINColor && activeModel?.productID) {
            fetchCarDesign((activeOutColor + "/" + activeINColor), activeModel?.productID);
            // getActivePartSection(activePart);

        }
    }, [activeINColor, activeOutColor, INcolorsCode, OUTcolorsCode, activePart]);

    useEffect(() => {

        // setActivePart(activePart);
        getActivePartSection(activePart);

    }, [outerCarImages, innerCarImages, wheels, activePart]);


    useEffect(() => {


        if (isLoadingImages == false)
            getActivePartSection(activePart);

    }, [isLoadingImages]);

    useEffect(() => {
        if (handleChangeOverViewContent && (features || gallery || models)) {
            handleChangeOverViewContent({
                ...vehicleInfo,
                hasFeatures: features?.length > 0,
                hasGallery: gallery?.length > 0,
                hasSpecs: models?.length > 0
            });
        }
    }, [features?.length, gallery?.length, models?.length]);

    //---------------------------render----------------------------------
    const formatPrice = (price) => {
        if (!price || price === 0 || price === '0') return null;
        return new Intl.NumberFormat('en-US').format(price);
    };

    const vhRef = useRef(null);

    return (
        <Fragment>
            {/* New-website promo: see THIS vehicle on the new Toyota/Lexus site.
                Only once the vehicle slug (productTarget) is resolved. */}
            {activeModel?.productTarget && (
                <NewSitePromo
                    vehicle={{
                        // The old product slug isn't a new-site slug — the new site
                        // resolves the vehicle from group + year via /vehicles/find.
                        url: `${/lexus|لكزس/i.test((activeModel?.brand || brand || "").toString()) ? "https://lexushj.com" : "https://toyotahj.com"}/vehicles/find?g=${encodeURIComponent(group || "")}&y=${encodeURIComponent(year || "")}`,
                        brand: (activeModel?.brand || brand || "").toString(),
                        name: activeModel?.name || activeModel?.modelDescription || group,
                    }}
                />
            )}
            {/* ═══ VEHICLE HERO ═══ */}
            <section className="vh" ref={vhRef}>
                <div className="container">
                    <div className="vh-row">
                        <div className="vh-img">
                            <div className="vh-badge">
                                {isLoadingModels ? <Skeleton width={80} height={20} /> : `${activeModel?.year || year} ${trans("info:model")}`}
                            </div>
                            <Swiper
                                className="slide-car-360"
                                spaceBetween={0}
                                slidesPerView={1}
                                navigation
                                effect="fade"
                                watchSlidesVisibility
                                watchSlidesProgress
                                autoplay={false}
                                loop={false}
                                observer={true}
                                updateOnWindowResize={true}
                            >
                                {isLoadingModels ? (
                                    <SwiperSlide className="px-3 slide-show">
                                        <Skeleton height={400} width="100%" borderRadius={20} />
                                    </SwiperSlide>
                                ) : filterCarImages?.length > 0 ? (
                                    filterCarImages.map((image, index) => (
                                        <SwiperSlide className="px-3 slide-show" key={index}>
                                            <img
                                                key={image?.Image_URL}
                                                className="lazyload"
                                                data-src={config?.FilePathURL + image?.Image_URL}
                                                alt={activeModel?.name}
                                            />
                                        </SwiperSlide>
                                    ))
                                ) : (
                                    <SwiperSlide className="px-3 slide-show">
                                        <img
                                            key={activeModel?.imagePath}
                                            className="lazyload"
                                            data-src={config?.mainURL + activeModel?.imagePath}
                                            alt={activeModel?.name}
                                        />
                                    </SwiperSlide>
                                )}
                            </Swiper>
                        </div>

                        <div className="vh-info">
                            <div className="vh-brand">{isLoadingModels ? <Skeleton width={100} height={24} /> : (activeModel?.brand || brand)}</div>
                            <h1 className="vh-name">
                                {isLoadingModels ? <Skeleton width="80%" height={48} /> : (
                                    <>
                                        {activeModel?.group || group} <span style={{ color: 'var(--g)', fontSize: '2.2rem' }}>{activeModel?.year || year}</span>
                                    </>
                                )}
                            </h1>
                            <p className="vh-tag">{isLoadingModels ? <Skeleton width="60%" height={24} /> : (activeModel?.modelDescription || activeModel?.name)}</p>

                            <div className="vh-colors-box" style={{
                                margin: '2.5rem 0',
                                padding: '1.8rem',
                                background: 'var(--bg2)',
                                borderRadius: '20px',
                                border: '1px solid rgba(0,0,0,0.04)',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.02)'
                            }}>
                                <div className="vh-colors-title" style={{
                                    fontSize: '1.8rem',
                                    fontWeight: '800',
                                    marginBottom: '1.5rem',
                                    color: 'var(--t3)',
                                    textAlign: 'center',

                                    textTransform: 'uppercase',
                                    letterSpacing: '1px'
                                }}>
                                    {trans("car:exterior_color")}
                                </div>
                                {isLoadingModels ? (
                                    <div className="clr-dots" style={{ display: 'flex', gap: '12px' }}>
                                        {[1, 2, 3, 4, 5].map(i => <Skeleton circle width={42} height={42} key={i} />)}
                                    </div>
                                ) : (
                                    <div className="clr-row" style={{ display: 'flex', flexDirection: 'column', gap: '1.2rem' }}>
                                        <div className="clr-dots" style={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            gap: '12px',
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        }}>
                                            {OUTcolors.filter(color => !outerCarImagesJson || (outerCarImagesJson[color.ColorID] && outerCarImagesJson[color.ColorID]?.length > 0)).map((color, index) => (
                                                <button
                                                    key={index}
                                                    className={`clr-dot ${activeOutColor === color.ColorID ? 'active' : ''}`}
                                                    style={{
                                                        width: '42px',
                                                        height: '42px',
                                                        borderRadius: '50%',
                                                        border: activeOutColor === color.ColorID ? '2px solid var(--g)' : '2px solid transparent',
                                                        padding: '2px',
                                                        background: 'transparent',
                                                        transition: 'all 0.3s ease',
                                                        cursor: 'pointer',
                                                        outline: 'none',
                                                        position: 'relative',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                    onClick={() => {
                                                        if (color.ColorID !== activeOutColor) {
                                                            setSelectedColor([]);
                                                            setActiveOutColor(color.ColorID);
                                                        }
                                                    }}
                                                    title={color.ColorDescription}
                                                >
                                                    <div style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        borderRadius: '50%',
                                                        backgroundColor: color.ColorID?.includes('089') ? '#f5f5f5' : (color.ColorID?.includes('S44') ? '#808080' : '#ecefef'),
                                                        backgroundImage: color.ColorImage
                                                            ? `url(${(config.FilePathURL + color.ColorImage).replaceAll('\\', '/')})`
                                                            : (color.ColorBase64 ? `url(data:image/png;base64,${color.ColorBase64})` : 'none'),
                                                        backgroundSize: 'cover',
                                                        backgroundPosition: 'center',
                                                        boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.1)',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        {!color.ColorImage && !color.ColorBase64 && (
                                                            <span style={{ fontSize: '9px', fontWeight: 'bold', color: '#555' }}>{color.ColorID}</span>
                                                        )}
                                                        {activeOutColor === color.ColorID && (
                                                            <div style={{
                                                                width: '18px',
                                                                height: '18px',
                                                                background: 'rgba(24, 169, 78, 0.9)',
                                                                borderRadius: '50%',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                boxShadow: '0 2px 6px rgba(0,0,0,0.2)'
                                                            }}>
                                                                <img src="/assets/icons/check.svg" alt="selected" style={{ width: '10px', height: '10px', filter: 'brightness(0) invert(1)' }} />
                                                            </div>
                                                        )}
                                                    </div>
                                                </button>
                                            ))}
                                        </div>
                                        <div
                                            key={selectedColor ? selectedColor.ColorID : activeModel?.productID}
                                            className={`clr-name ${lang === 'ar' ? 'animate-label-ar' : 'animate-label-en'}`}
                                            style={{
                                                fontSize: '1.5rem',
                                                fontWeight: '700',
                                                color: 'var(--t1)',
                                                borderLeft: lang === 'ar' ? 'none' : '3px solid var(--g)',
                                                borderRight: lang === 'ar' ? '3px solid var(--g)' : 'none',
                                                padding: lang === 'ar' ? '0 1rem 0 0' : '0 0 0 1rem',
                                                transition: 'all 0.3s ease',
                                                textAlign: 'center',
                                                minHeight: '3.6rem',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            {selectedColor ? (lang === "ar" ? selectedColor?.ColorDescriptionAr?.split("/")[0] : selectedColor?.ColorDescriptionEn?.split("/")[0]) : (activeModel?.name)}
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="vh-btns">
                                {isLoadingModels ? (
                                    <>
                                        <Skeleton width={120} height={50} style={{ borderRadius: '30px' }} />
                                        <Skeleton width={120} height={50} style={{ borderRadius: '30px' }} />
                                        <Skeleton width={120} height={50} style={{ borderRadius: '30px' }} />
                                    </>
                                ) : (
                                    <>
                                        <button className="vh-cta green" onClick={() => setSectionActive("specs")}>
                                            <svg viewBox="0 0 24 24"><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z" /></svg>
                                            {trans("vehicales:veh-d-home-specs")}
                                        </button>
                                        <button className="vh-cta outline" onClick={() => {
                                            if (popRef.current) {
                                                popRef.current.toggleFullScreen();
                                            }
                                        }}>
                                            <img src='/assets/icons/gallery.svg' width={20} height={20} alt="gallery" />
                                            {trans("car:gallery")}
                                        </button>
                                        <ReactWhatsapp className="vh-cta wa" number="+966920018996" message={i18n?.language == "ar" ? `أنا مهتم بـ ${activeModel?.name} ${activeModel?.modelDescription || activeModel?.name} ${activeModel?.year || year} ${activeModel?.brand || brand}` : `I am interested in the ${activeModel?.name} ${activeModel?.modelDescription || activeModel?.name} ${activeModel?.year || year} ${activeModel?.brand || brand}`} target="_blank" rel="noreferrer">
                                            <svg viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" /></svg>
                                            {trans("info:whatsapp_number")}
                                        </ReactWhatsapp>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ═══ SPECS BAR ═══ */}
            <div className="container">
                <div className="specs-bar">
                    {isLoadingModels ? (
                        [1, 2, 3, 4, 5, 6].map((i) => (
                            <div className="sb-item" key={i}>
                                <Skeleton circle width={32} height={32} className="mb-2" />
                                <Skeleton width={60} height={18} />
                                <Skeleton width={40} height={12} />
                            </div>
                        ))
                    ) : activeModel ? (
                        (() => {
                            const hp = activeModel?.horsePower || activeModel?.hp || activeModel?.HorsePower || activeModel?.NoteEn?.match(/(\d+)\s*HP/)?.[1] || activeModel?.NoteAr?.match(/(\d+)\s*حصان/)?.[1];
                            const cyl = activeModel?.cylinders || activeModel?.cyl || activeModel?.Cylinders || activeModel?.NoteEn?.match(/(\d+)-Cylinders/)?.[1] || activeModel?.NoteAr?.match(/(\d+)\s*-اسطوانات/)?.[1];
                            const engine = activeModel?.NoteEn?.match(/Engine:\s*(\d+\.\d+)L/)?.[1] || activeModel?.NoteAr?.match(/المحرك:\s*(\d+\.\d+)\s*لتر/)?.[1] || (activeModel?.liter < 10 ? activeModel?.liter : null);
                            const fuelTank = activeModel?.liter >= 10 ? activeModel?.liter : (activeModel?.NoteEn?.match(/Fuel Tank Capacity:\s*(\d+)\s*L/)?.[1] || activeModel?.NoteAr?.match(/سعة خزان الوقود:\s*(\d+)\s*لتر/)?.[1]);
                            const seats = activeModel?.seatsNumber || activeModel?.seats || activeModel?.NoteEn?.match(/Seats:\s*(\d+)/)?.[1] || "5";

                            return (
                                <Fragment>
                                    <div className="sb-item">
                                        <img src="/assets/icons/specs/horse-power.svg" alt="hp" className="filter-green" />
                                        <div className="sb-val">{hp || "---"} HP</div>
                                        <div className="sb-lbl">{trans("info:horsePower") || "Power"}</div>
                                    </div>
                                    <div className="sb-item">
                                        <img src="/assets/icons/specs/cylinder.svg" alt="cylinder" className="filter-green" />
                                        <div className="sb-val">{cyl || "---"} Cyl</div>
                                        <div className="sb-lbl">{trans("info:cylinders") || "Engine"}</div>
                                    </div>
                                    <div className="sb-item">
                                        <img src="/assets/icons/specs/petrol.svg" alt="engine" className="filter-green" />
                                        <div className="sb-val">{engine ? `${engine}L` : (fuelTank ? `${fuelTank}L` : "---")}</div>
                                        <div className="sb-lbl">{engine ? trans("info:liter") : trans("info:fuel_tank")}</div>
                                    </div>
                                    <div className="sb-item">
                                        <img src="/assets/icons/specs/petrol.svg" alt="petrol" className="filter-green" />
                                        <div className="sb-val">{activeModel?.petrol || "91"}</div>
                                        <div className="sb-lbl">{trans("info:petrol") || "Fuel Type"}</div>
                                    </div>
                                    <div className="sb-item">
                                        <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="3" /><path d="M12 1v2m0 18v2M4.22 4.22l1.42 1.42m12.72 12.72l1.42 1.42M1 12h2m18 0h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" /></svg>
                                        <div className="sb-val">{"CVT"}</div>
                                        <div className="sb-lbl">{trans("info:transmission") || "Transmission"}</div>
                                    </div>
                                    <div className="sb-item">
                                        <img src="/assets/icons/specs/seats.svg" alt="seats" className="filter-green" />
                                        <div className="sb-val">{seats}</div>
                                        <div className="sb-lbl">{trans("info:seatsNumber") || "Seats"}</div>
                                    </div>
                                </Fragment>
                            );
                        })()
                    ) : (
                        <div className="w-full text-center py-4">
                            <EmptyState message={trans("vehicales:no-specs-data") || "No specifications available"} />
                        </div>
                    )}
                </div>
            </div>

            {/* ═══ FEATURES ═══ */}
            <section className="sec" style={{ paddingTop: '3rem' }}>
                <div className="container">
                    <div className="sec-head">
                        <h2>{trans("car:features")}</h2>
                        <p>{trans("vehicales:veh-d-home-feature-desc") || "What makes this vehicle stand apart"}</p>
                    </div>
                    {isLoadingFeatures ? (
                        <div className="ftg">
                            {[1, 2, 3].map(i => (
                                <div className="ft-card" key={i}>
                                    <Skeleton circle width={48} height={48} className="mb-4" />
                                    <Skeleton width="80%" height={24} className="mb-2" />
                                    <Skeleton count={2} />
                                </div>
                            ))}
                        </div>
                    ) : features?.length > 0 ? (
                        isMobile ? (
                            <Swiper
                                slidesPerView={1.2}
                                spaceBetween={20}
                                pagination={{ clickable: true }}
                                className="ft-swiper pb-10"
                            >
                                {features.map((feature, index) => (
                                    <SwiperSlide key={index}>
                                        <div className="ft-card h-100">
                                            <div className="ft-icon">
                                                <svg viewBox="0 0 24 24"><path d="M13 2L3 14h9l-1 10 10-12h-9l1-10z" /></svg>
                                            </div>
                                            <h3>{feature.title}</h3>
                                            <p>{feature.desc}</p>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        ) : (
                            <div className="ftg">
                                {features.map((feature, index) => (
                                    <div className="ft-card" key={index}>
                                        <div className="ft-icon">
                                            <svg viewBox="0 0 24 24"><path d="M13 2L3 14h9l-1 10 10-12h-9l1-10z" /></svg>
                                        </div>
                                        <h3>{feature.title}</h3>
                                        <p>{feature.desc}</p>
                                    </div>
                                ))}
                            </div>
                        )
                    ) : (
                        <EmptyState message={trans("vehicales:no-features-data") || "No features available"} />
                    )}
                </div>
            </section>

            {/* ═══ TRIMS / MODELS ═══ */}
            <section className="sec" style={{ background: 'var(--bg2)' }}>
                <div className="container">
                    <div className="sec-head">
                        <h2>{trans("car:available-models")}</h2>
                        <p>{trans("info:choose_trim") || "Choose the perfect specification for your lifestyle"}</p>
                    </div>
                    {isLoadingModels ? (
                        <div className="tr-grid">
                            {[1, 2, 3].map(i => (
                                <div className="tr-card" key={i}>
                                    <Skeleton height={200} borderRadius={16} className="mb-4" />
                                    <Skeleton width="80%" height={24} className="mb-2" />
                                    <Skeleton width="40%" height={32} />
                                </div>
                            ))}
                        </div>
                    ) : models?.filter(m => !m.modelDescription?.toLowerCase().includes("1l5") && !m.name?.toLowerCase().includes("1l5") && !m.type?.toLowerCase().includes("1l5")).length > 0 ? (
                        isMobile ? (
                            <Swiper
                                slidesPerView={1.1}
                                spaceBetween={20}
                                pagination={{ clickable: true }}

                                className="tr-swiper pb-10"
                            >
                                {models.map((model, index) => {
                                    const isOnline = model?.BuyOnline || model?.buyOnline;
                                    const features = model?.note?.split('\n').filter(f => f.trim() !== '').slice(0, 5);

                                    return (
                                        <SwiperSlide key={index}>
                                            <div
                                                className={`tr-card h-100 ${activeModel?.productID === model.productID ? 'tr-rec' : ''} ${isOnline ? 'online-card' : ''}`}
                                                style={{ cursor: 'pointer', position: 'relative' }}
                                            >
                                                {isOnline && (
                                                    <div className="tr-badge-online">
                                                        {trans("info:Available_for_purchase_online")}
                                                    </div>
                                                )}

                                                <div
                                                    className="tr-img-container"
                                                    onClick={() => {
                                                        setActiveModel(model);
                                                        if (vhRef.current) {
                                                            vhRef.current.scrollIntoView({ behavior: 'smooth' });
                                                        }
                                                    }}
                                                >
                                                    <img
                                                        data-src={config?.mainURL + model.imagePath}
                                                        className="lazyload"
                                                        alt={model.modelDescription}
                                                    />
                                                </div>

                                                <div className="tr-content-box">
                                                    <h4 className="text-3xl">{model.modelDescription}</h4>
                                                    {formatPrice(model.minPrice || model.NetSalePrice) ? (
                                                        <Price price={model.minPrice || model.NetSalePrice} className="tr-price text-[#23cc4f]" />
                                                    ) : (
                                                        <div className="tr-price-placeholder" style={{ height: '28px' }}></div>
                                                    )}

                                                    <button
                                                        className="tr-buy-btn primary-variant"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            sendRequest(model);
                                                        }}
                                                    >
                                                        <img src='/assets/icons/cart.svg' alt="cart" className="filter-primary" />
                                                        <span className="text-18 sm:text-20">{trans("info:buy")}</span>
                                                    </button>

                                                    <div className="tr-features">
                                                        {features && features.length > 0 && (
                                                            <ul>
                                                                {features.map((f, i) => (
                                                                    <li key={i}>{f}</li>
                                                                ))}
                                                            </ul>
                                                        )}
                                                    </div>

                                                    <div className="tr-actions-footer">
                                                        <Link
                                                            to={`${mainurl}/specs/${model?.productTarget}`}
                                                            className="view-more text-primary"
                                                        >
                                                            {trans("common:show-more")}
                                                        </Link>

                                                        <button
                                                            className={`select-btn ${activeModel?.productID === model.productID ? 'active' : ''}`}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setActiveModel(model);
                                                                if (vhRef.current) {
                                                                    vhRef.current.scrollIntoView({ behavior: 'smooth' });
                                                                }
                                                            }}
                                                        >
                                                            {activeModel?.productID === model.productID ? trans("info:selected") : trans("info:select_trim")}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    );
                                })}
                            </Swiper>
                        ) : (
                            <div className="tr-grid">
                                {models.map((model, index) => {
                                    const isOnline = model?.BuyOnline || model?.buyOnline;
                                    const features = model?.note?.split('\n').filter(f => f.trim() !== '').slice(0, 5);

                                    return (
                                        <div
                                            className={`tr-card ${activeModel?.productID === model.productID ? 'tr-rec' : ''} ${isOnline ? 'online-card' : ''}`}
                                            key={index}
                                            style={{ cursor: 'pointer', position: 'relative' }}
                                        >
                                            {isOnline && (
                                                <div className="tr-badge-online">
                                                    {trans("info:Available_for_purchase_online")}
                                                </div>
                                            )}

                                            <div
                                                className="tr-img-container"
                                                onClick={() => {
                                                    setActiveModel(model);
                                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                                }}
                                            >
                                                <img
                                                    data-src={config?.mainURL + model.imagePath}
                                                    className="lazyload"
                                                    alt={model.modelDescription}
                                                />
                                            </div>

                                            <div className="tr-content-box">
                                                <h4 className="text-3xl">{model.modelDescription}</h4>
                                                {formatPrice(model.minPrice || model.NetSalePrice) ? (
                                                    <Price price={model.minPrice || model.NetSalePrice} className="tr-price text-[#23cc4f]" />
                                                ) : (
                                                    <div className="tr-price-placeholder" style={{ height: '28px' }}></div>
                                                )}

                                                <button
                                                    className="tr-buy-btn primary-variant"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        sendRequest(model);
                                                    }}
                                                >
                                                    <img src='/assets/icons/cart.svg' alt="cart" className="filter-primary" />
                                                    <span className="text-18 sm:text-20">{trans("info:buy")}</span>
                                                </button>

                                                <div className="tr-features">
                                                    {features && features.length > 0 && (
                                                        <ul>
                                                            {features.map((f, i) => (
                                                                <li key={i}>{f}</li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </div>

                                                <div className="tr-actions-footer">
                                                    <Link
                                                        to={`${mainurl}/specs/${model?.productTarget}`}
                                                        className="view-more text-primary"
                                                    >
                                                        {trans("common:show-more")}
                                                    </Link>

                                                    <button
                                                        className={`select-btn ${activeModel?.productID === model.productID ? 'active' : ''}`}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setActiveModel(model);
                                                            if (vhRef.current) {
                                                                vhRef.current.scrollIntoView({ behavior: 'smooth' });
                                                            } else {
                                                                window.scrollTo({ top: 0, behavior: 'smooth' });
                                                            }
                                                        }}
                                                    >
                                                        {activeModel?.productID === model.productID ? trans("info:selected") : trans("info:select_trim")}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )
                    ) : (
                        <EmptyState message={trans("vehicales:no-models-data") || "No available models found"} />
                    )}
                </div>
            </section>


            {/* ═══ GALLERY ═══ */}
            <section className="sec" style={{ paddingTop: '3rem' }}>
                <div className="container">
                    <div className="sec-head">
                        <h2>{trans("car:gallery")}</h2>
                    </div>
                    {isLoadingGallery ? (
                        <div className="simple-gallery">
                            {[1, 2, 3, 4, 5, 6].map(i => (
                                <div key={i} className="simple-gallery-item" style={{ height: '200px' }}>
                                    <Skeleton width="100%" height="100%" borderRadius={16} />
                                </div>
                            ))}
                        </div>
                    ) : gallery?.length > 0 ? (
                        <div className="simple-gallery">
                            {gallery.slice(0, 6).map((img, index) => (
                                <div
                                    key={index}
                                    className="simple-gallery-item"
                                    onClick={() => {
                                        if (popRef.current) {
                                            popRef.current.toggleFullScreen();
                                            popRef.current.slideToIndex(index);
                                        }
                                    }}
                                >
                                    <img
                                        data-src={config.FilePathURL + img.imagePath}
                                        className="lazyload object-full object-cover"
                                        alt="car gallery"
                                    />
                                    <span className="simple-gallery-item-ovrlay">
                                        <svg className="image-gallery-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path>
                                        </svg>
                                    </span>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <EmptyState message={trans("vehicales:no-gallery-data") || "No gallery available"} />
                    )}
                </div>
            </section>

            <div style={{ opacity: isFullScreen ? 1 : 0, position: isFullScreen ? "relative" : "fixed", zIndex: isFullScreen ? 999999 : -1 }}>
                <ImageGallery ref={popRef} items={gallery} onScreenChange={(e) => setIsFullScreen(e)} />
            </div>
        </Fragment >
    );
};
